import React from 'react';
import styled from 'styled-components';
import LoadingOverlay from 'react-loading-overlay';
import Header from '../../components/common/header/Header';
import { useDispatch, useSelector } from 'react-redux';
import CustomTitle from '../../components/common/title/CustomTitle';
import Footer from '../../components/common/Footer';
import { useState } from 'react';
import NormalBtn from '../../components/common/button/NormalBtn';
import BootPay from "bootpay-js";
import { useEffect } from 'react';
import { setCurMenuAction, setHeaderTransferAction } from '../../modules/common/headerModule';
import { useHistory, Link, Redirect } from 'react-router-dom';
import { findAction, resetStatusAction } from '../../modules/su/userCheckModule';
import {isMobileOnly} from 'react-device-detect';

const SiFindIdBlock = styled.div`
    width: 100%;
    margin: 0 auto;
    padding-top: 80px;
`;

const SiContentsBlock = styled.div`
    padding: 90px 0 120px;
    background-color: #f4f4f4;
`;

const SiContentsBoxBlock = styled.div`
    width: 520px;
    padding: 50px 60px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 6px;
`;

const SiContentsDivBlock = styled.div`
    text-align: center;
`;

const SiContetnsUlBlock = styled.ul`
    display: inline-block;
    margin-left: -50px;
    margin-bottom: 50px;
`;

const SiContentsLiBlock = styled.li`
    float: left;
    padding-left: 50px;
    color: ${prods => prods.color || '#999'};
    font-size: 18px;
    font-weight: 500;
`;

const SiContentsLiGreenBorderBlock = styled.span`
    position: relative;
    z-index: 1;

    ::after {
        bottom: 3px;
        content: "";
        display: block;
        position: absolute;
        left: 0;
        width: 100%;
        height: 3px;
        background-color: #79b88a;
        z-index: -1;
    }
`;

const SiGuideBlock = styled.p`
    ${isMobileOnly?`
    font-size: ${props => props.fontsize || '14px'};
    `:`
    font-size: 16px;
    `};

    display: block;
    color: ${props => props.color || '#333'};
    
    font-weight: 400;
    text-align: center;
    margin-bottom: ${props => props.bottom || '40px'};

    ::before {
        content: '';
        display: ${props => props.error || 'none'};//inline-block;
        width: 16px;
        height: 16px;
        margin-right: 7px;
        background: url(/assets/images/icon/error-icon.png) center center/cover no-repeat;
        vertical-align: -3px;
    }
`;

const SiGuideIdBlock = styled.span`
    display: ${props => props.display || 'none'};
    
    color: #333333;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.33;

    ${isMobileOnly?`
    margin-top: 10px;
    `:`
    margin-top: 20px;
    `};
`;

const SiGuideSmallBlock = styled.p`
    display: ${props => props.display || 'none'};;
    color: ${props => props.color || '#333'};
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    ${isMobileOnly?`
    margin-bottom: 10px;
    `:`
    margin-bottom: 20px;
    `};
`;

const SiFindIdMBlock = styled.div`
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;

    .header-block {
        width: 100vw;
        
        height: 50px;
        background-color: #ffffff;
        position: relative;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        color: #111111;
        line-height: 50px;

        .back {
            width: 36px;
            height: 36px;
            position: absolute;
            top: 7px;
            left: 2px;
            background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
        }
    }

    .top-btn {
        width: 50vw;
        cursor: pointer;
        float:left;
        height: 50px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #cccccc;
        border-bottom: 1px solid #e7e7e7;
    }

    .active {
        cursor: none;
        color: #111111;
        border-bottom: 3px solid #ffc742;
    }

    .contens {
        margin: 0 4vw;
    }
`;

const SiFindId = () => {

    const dispatch = useDispatch();

    const [status, setStatus] = useState(0);
    const [btnTxt, setBtnText] = useState("본인인증 하기");
    const [guideTxt, setGuideText] = useState("회원가입 시 본인 인증한 정보입니다.");
    const [id, setId] = useState(null);

    const { checkStatus, loading, message, accessToken } = useSelector(
        ({ userCheckReducer, loadingReducer, userReducer }) => ({
            loading: loadingReducer['user/FIND'],
            checkStatus: userCheckReducer.checkStatus,
            message: userCheckReducer.message,
            accessToken: userReducer.accessToken
        })
    );

    const history = useHistory();

    useEffect(() => {

        dispatch(setCurMenuAction('si/findid'));
        dispatch(setHeaderTransferAction(false));

        if (checkStatus !== null) {
            if (checkStatus === 200) {
                if (status !== 2) {
                    setStatus(2);
                    setGuideText("아이디 찾기 결과 입니다.");
                    setId(message);
                    setBtnText("로그인 하기");
                }

            } else {
                if (status !== 1) {
                    setStatus(1);
                    setGuideText(message);
                    if(isMobileOnly) {
                        setBtnText("이메일로 회원가입");
                    } else {
                        setBtnText("회원가입하러 가기");
                    }
                
                }
            }
        }

        return function cleanup() {
            // console.log("--------cleanup !!!")
            dispatch(resetStatusAction());
        }

    }, [checkStatus])


    const handleConfirmClick = () => {

        if (status === 1) {
            history.push("/register");
            dispatch(resetStatusAction());
        } else if (status === 2) {
            history.push("/login");
            dispatch(resetStatusAction());
        } else {
            reqBootpay();
        }

        setStatus(0);
    }

    const reqBootpay = () => {
        let d = new Date();
        // 본인 인증 처리 시작 
        // console.log(" 본인 인증 처리 시작 ---------> ")
        BootPay.request({
            price: 0, // 0으로 해야 한다.
            application_id: process.env.REACT_APP_BOOTPAY_ID,
            name: process.env.REACT_APP_BOOTPAY_NAME, //결제창에서 보여질 이름
            pg: 'danal',
            method: 'auth', // 빌링키를 받기 위한 결제 수단
            show_agree_window: 0, // 부트페이 정보 동의 창 보이기 여부
            order_id: 'ODGAGU' + d.getTime(),
            params: {},
            extra: {
                age_limit: '14'
            }
        }).error(function (data) {
            // 본인인증 진행시 에러가 발생하면 수행됩니다.
            // console.log(" error : " + JSON.stringify(data));
        }).cancel(function (data) {
            // 본인인증이 취소되면 수행됩니다.
            // console.log("취소 : " + JSON.stringify(data));
        }).done(function (data) {
            // 서버에 data 확인 
            // console.log("완료 : " + JSON.stringify(data));
            dispatch(findAction(data));
        });
    }

    const getBtnColor = () => {

        if(isMobileOnly) {
            if (status === 0) {
                return "#ffffff";
            } else if (status === 1){
                return "#333333"
            } else {
                return "#111111";
            }
        } else {
            if (status <= 1) {
                return "#fff";
            } else {
                return "#111";
            }
        }
        
    }

    const getBtnBgColor = () => {

        if(isMobileOnly) {
            if (status === 0) {
                return "#333333"
            } else if (status === 1){
                return "#ffffff"
            } else {
                return "#ffc742";
            }
        } else {
            if (status <= 1) {
                return "#111";
            } else {
                return "#ffc742";
            }
        }
        
    }

    const getBorderColor = () => {
        if (status === 1){
            return "#cccccc"
        }

    }

    //#2771 탭선택시 초기화
    const handleBtnResetPW = () => {
        dispatch(resetStatusAction());
        if(isMobileOnly) {
            return history.replace('/resetpw');
        }
        return history.push('/resetpw');
    }

    const handleBack = () => {
        history.goBack();
    }

    // 로그인 상태이면 
    if (accessToken !== null && accessToken.length > 0) {
        return <Redirect to="/" />
    }

    return (
        isMobileOnly?
        <SiFindIdMBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''>
                <div className="header-block">
                    <button className="back" onClick={handleBack} />
                    계정 찾기
                </div>
                <div className="clearfix margin_b-40">
                    <button className="top-btn active">아이디 찾기</button>
                    <button className="top-btn" onClick={handleBtnResetPW}>비밀번호 재설정</button>
                </div>
                <div className="contens">
                    <SiGuideBlock style={{fontSize:status === 1 ? '12px' : '14px'} } color={status === 1 ? '#f80053' : '#333'} error = {status === 1 ? 'inline-block' : 'none'} bottom={status === 2 ? '30px':'40px'}>
                                {guideTxt}
                                <SiGuideIdBlock display={id ? 'block' : 'none'}>
                                    {id}
                                </SiGuideIdBlock>
                    </SiGuideBlock>
                    <SiGuideSmallBlock display={status === 1 ? 'block' : 'none'} color={"#999999"}>
                    아직 어디가구의 나무님이 아니신가요?
                    </SiGuideSmallBlock>
                    <NormalBtn width="100%"
                            onClick={handleConfirmClick}
                            lineHeight="52px"
                            bgColor={getBtnBgColor()}
                            textColor={getBtnColor()}
                            height="52px" borderRadius="4px"
                            fontSize="16px" fontWeight="400"
                            marginBottom="10px" marginTop="0px" float="none"
                            borderColor={getBorderColor()}
                            text={btnTxt} />
                </div>

            </LoadingOverlay >

        </SiFindIdMBlock>
        :
        <SiFindIdBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''>

                <Header />
                <SiContentsBlock>
                    <SiContentsBoxBlock>
                        <CustomTitle title="계정 찾기" textColor="#111" />
                        <SiContentsDivBlock>
                            <SiContetnsUlBlock>
                                <SiContentsLiBlock color='#111'>
                                    <SiContentsLiGreenBorderBlock>
                                        아이디 찾기
                                    </SiContentsLiGreenBorderBlock>
                                </SiContentsLiBlock>
                                <SiContentsLiBlock onClick={handleBtnResetPW} style={{cursor:'pointer'}}>비밀번호 재설정</SiContentsLiBlock>
                            </SiContetnsUlBlock>
                        </SiContentsDivBlock>

                        <SiGuideBlock color={status === 1 ? '#f80053' : '#333'}>
                            {guideTxt}
                            <SiGuideIdBlock display={id ? 'block' : 'none'}>
                                {id}
                            </SiGuideIdBlock>
                        </SiGuideBlock>

                        <SiGuideSmallBlock display={status === 1 ? 'block' : 'none'}>
                            어디가구 회원이 아니시라면?
                        </SiGuideSmallBlock>

                        <NormalBtn width="100%"
                            onClick={handleConfirmClick}
                            lineHeight="58px"
                            bgColor={getBtnBgColor}
                            textColor={getBtnColor}
                            height="60px" borderRadius="30px"
                            fontSize="22px" fontWeight="400"
                            marginBottom="10px" marginTop="0px" float="none"
                            text={btnTxt} />

                    </SiContentsBoxBlock>
                </SiContentsBlock>
                <Footer />
            </LoadingOverlay >

        </SiFindIdBlock>
    );
};

export default SiFindId;